import React from 'react';
import logo from './logo.svg';
import './App.css';

function App() {
  return (
    <div style={{width: "100%", margin: 'auto', maxWidth:'1024px'}}>
      <h3>Política de Privacidade</h3>
      <h5>1. Termos</h5><br></br>
      Ao acessar a Preser, concorda em cumprir estes termos de serviço, todas as
      leis e regulamentos aplicáveis e concorda que é responsável pelo
      cumprimento de todas as leis locais aplicáveis. Se você não concordar com
      algum desses termos, está proibido de usar ou acessar este site. Os
      materiais contidos neste site são protegidos pelas leis de direitos autorais e
      marcas comerciais aplicáveis.
      <h5>2. Uso de Licença</h5><br></br>
      É concedida permissão para baixar temporariamente uma cópia dos
      materiais (informações ou software) no site Preser , apenas para
      visualização transitória pessoal e não comercial. Esta é a concessão de uma
      licença, não uma transferência de título e, sob esta licença, você não pode:
      <ul>
        <li>
          1. modificar ou copiar os materiais;
        </li>
        <li>
          2. usar os materiais para qualquer finalidade comercial ou para exibição
        pública (comercial ou não comercial);
        </li>
        <li>
          3. tentar descompilar ou fazer engenharia reversa de qualquer software
        contido no site Preser;
        </li>
        <li>
          4. remover quaisquer direitos autorais ou outras notações de
        propriedade dos materiais; ou
        </li>
        <li>
          5. transferir os materiais para outra pessoa ou 'espelhe' os materiais em
        qualquer outro servidor.
        </li>
      </ul>
      Esta licença será automaticamente rescindida se você violar alguma
      dessas restrições e poderá ser rescindida por Preser a qualquer momento.
      Ao encerrar a visualização desses materiais ou após o término desta
      licença, você deve apagar todos os materiais baixados em sua posse, seja
      em formato eletrónico ou impresso.
      <h5>3. Isenção de responsabilidade</h5><br></br>
      <ul>
        <li>
          1. Os materiais no site da Preser são fornecidos 'como estão'. Preser não
        oferece garantias, expressas ou implícitas, e, por este meio, isenta e
        nega todas as outras garantias, incluindo, sem limitação, garantias
        implícitas ou condições de comercialização, adequação a um fim
        específico ou não violação de propriedade intelectual ou outra
        violação de direitos.
        </li>
        <li>
          2. Além disso, o Preser não garante ou faz qualquer representação
        relativa à precisão, aos resultados prováveis ou à confiabilidade do
        uso dos materiais em seu site ou de outra forma relacionado a esses
        materiais ou em sites vinculados a este site.
        </li>
      </ul>
      <h5>4. Limitações</h5><br></br>
      Em nenhum caso o Preser ou seus fornecedores serão responsáveis ​por
      quaisquer danos (incluindo, sem limitação, danos por perda de dados ou
      lucro ou devido a interrupção dos negócios) decorrentes do uso ou da
      incapacidade de usar os materiais em Preser, mesmo que Preser ou um
      representante autorizado da Preser tenha sido notificado oralmente ou por
      escrito da possibilidade de tais danos. Como algumas jurisdições não
      permitem limitações em garantias implícitas, ou limitações de
      responsabilidade por danos consequentes ou incidentais, essas limitações
      podem não se aplicar a você.
      <h5>5. Precisão dos materiais</h5><br></br>
      Os materiais exibidos no site da Preser podem incluir erros técnicos,
      tipográficos ou fotográficos. Preser não garante que qualquer material em
      seu site seja preciso, completo ou atual. Preser pode fazer alterações nos
      materiais contidos em seu site a qualquer momento, sem aviso prévio. No
      entanto, Preser não se compromete a atualizar os materiais.
      <h5>6. Links</h5><br></br>
      O Preser não analisou todos os sites vinculados ao seu site e não é
      responsável pelo conteúdo de nenhum site vinculado. A inclusão de
      qualquer link não implica endosso por Preser do site. O uso de qualquer
      site vinculado é por conta e risco do usuário.
      Quando você clica em links no preser, eles podem lhe direcionar para fora do nosso site. Não
      somos responsáveis pelas práticas de privacidade de outros sites e lhe incentivamos a ler as
      declarações de privacidade deles.
      <h5>7. Uso dos dados</h5><br></br>
      Quando você realiza alguma transação com o Preser, como parte do processo de compra e
      venda, coletamos as informações pessoais que você nos dá tais como: nome, e-mail e
      endereço.Quando você acessa nosso app, sua localização é solicitada e compartilhada para devida
      execução da atividade de rastreio do app.
      Quando você acessa nosso site, também recebemos automaticamente o protocolo de internet
      do seu computador, endereço de IP, a fim de obter informações que nos ajudam a aprender
      sobre seu navegador e sistema operacional.
      Email Marketing será realizado apenas caso você permita. Nestes emails você poderá
      receber notícias sobre Preser, novos produtos e outras atualizações.
      <h5>7.1 Dados em segundo plano</h5><br></br>
      <ul>
      <li>
        1. Este app coleta dados de localização para ativar o monitoramento da localização
      atual do pronta-resposta durante as ocorrências, mesmo quando o app está fechado
      ou não está em uso.
      </li>
      <li>
        2. Este app coleta dados de localização para apresentar notificação de novas
      ocorrências próximas ao usuário mesmo quando o app está fechado ou não está em
      uso
      </li>
      </ul>
      <h5>8. Consentimento</h5><br></br>
      Como vocês obtêm meu consentimento?
      Quando você fornece informações pessoais como nome, telefone e endereço, para
      completar: uma transação, verificar seu cartão de crédito, fazer um pedido, providenciar
      uma entrega ou retornar uma compra. Após a realização de ações entendemos que você está
      de acordo com a coleta de dados para serem utilizados pela nossa empresa.
      Se pedimos por suas informações pessoais por uma razão secundária, como marketing, vamos
      lhe pedir diretamente por seu consentimento, ou lhe fornecer a oportunidade de dizer não.
      E caso você queira retirar seu consentimento, como proceder?
      Se após você nos fornecer seus dados, você mudar de ideia, você pode retirar o seu
      consentimento para que possamos entrar em contato, para a coleção de dados contínua, uso
      ou divulgação de suas informações, a qualquer momento, entrando em contato conosco em
      natan@bwsiot.com ou nos enviando uma correspondência em: PRMA Pronta Resposta,
      Rua Calçada das Acácias, 31, Andar 3 Sala 3, Condomínio Centro Comercial Alphaville -
      CEP 06453-054.
      <h5>9. Serviços de terceiros</h5><br></br>
      No geral, os fornecedores terceirizados usados por nós irão apenas coletar, usar e divulgar
      suas informações na medida do necessário para permitir que eles realizem os serviços que
      eles nos fornecem.Entretanto, certos fornecedores de serviços terceirizados, tais como gateways de pagamento
      e outros processadores de transação de pagamento, têm suas próprias políticas de
      privacidade com respeito à informação que somos obrigados a fornecer para eles de suas
      transações relacionadas com compras.
      Para esses fornecedores, recomendamos que você leia suas políticas de privacidade para que
      você possa entender a maneira na qual suas informações pessoais serão usadas por esses
      fornecedores.
      Em particular, lembre-se que certos fornecedores podem ser localizados em ou possuir
      instalações que são localizadas em jurisdições diferentes que você ou nós. Assim, se você
      quer continuar com uma transação que envolve os serviços de um fornecedor de serviço
      terceirizado, então suas informações podem tornar-se sujeitas às leis da(s) jurisdição(ões)
      nas quais o fornecedor de serviço ou suas instalações estão localizados. Uma vez que você
      deixe o site da Preser ou seja redirecionado para um aplicativo ou site de terceiros, você
      não será mais regido por essa Política de Privacidade ou pelos Termos de Serviço do nosso
      site.
      <h5>10. Divulgação</h5><br></br>
      Podemos divulgar suas informações pessoais caso sejamos obrigados pela lei para
      fazê-lo ou se você violar nossos Termos de Serviço.
      <h5>11. Segurança</h5><br></br>
      Para proteger suas informações pessoais, tomamos precauções razoáveis e seguimos as
      melhores práticas da indústria para nos certificar que elas não serão perdidas
      inadequadamente, usurpadas, acessadas, divulgadas, alteradas ou destruídas.
      Se você fornecer as suas informações de cartão de crédito, essa informação é criptografada
      usando tecnologia "secure socket layer" (SSL) e armazenada com uma criptografia
      AES-256. Embora nenhum método de transmissão pela Internet ou armazenamento
      eletrônico seja 100% seguro, nós seguimos todos os requisitos da PCI-DSS e
      implementamos padrões adicionais geralmente aceitos pela indústria.
      <h5>12. Modificações</h5><br></br>
      O Preser pode revisar estes termos de serviço do site a qualquer momento,
      sem aviso prévio. Ao usar este site, você concorda em ficar vinculado à
      versão atual destes termos de serviço. Alterações e esclarecimentos vão surtir efeito
      imediatamente após sua publicação no site. Se fizermos alterações de materiais para essa
      política, iremos notificá-lo aqui que eles foram atualizados, para que você tenha ciência sobrequais informações coletamos, como as usamos, e sob que circunstâncias, se alguma, usamos
      e/ou divulgamos elas.
      Se o Preser for adquirido ou fundido com outra empresa, suas informações podem ser
      transferidas para os novos proprietários para que possamos continuar a vender produtos para
      você.
    </div>  
  )
}

export default App;
